import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared/shared.module';
import { ButtonWithIndicatorModule } from '../../../button-with-indicator/button-with-indicator.module';
import { ModalWindowModule } from '../../../modal-window/modal-window.module';
import { PhoneNumbersComponent } from './phone-numbers.component';
import { AgEditorToolbarModule } from '../../../ag-editor-toolbar/ag-editor-toolbar.module';

@NgModule({
  imports: [SharedModule, ModalWindowModule, ButtonWithIndicatorModule, AgEditorToolbarModule],
  declarations: [PhoneNumbersComponent],
  exports: [PhoneNumbersComponent],
})
export class PhoneNumbersModule {}
